import React from 'react';
import styled from 'styled-components';
import * as BuilderUI from '../../../../../components/Builder/BuilderUI';
import KubitTooltip from '../../../../../components/KubitTooltip';
import SignificanceConfidenceLevel from './SignificanceConfidenceLevel';
import SignificanceLevel from './SignificanceLevel';
import SignificanceTestType from './SignificanceTestType';
import {
  significanceConfidenceLevelInfo,
  significancePValueInfo,
  significanceTestInfo,
} from '../utils/tooltips';

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
`;

const SignificanceTestSettings = () => {
  return (
    <Container>
      <BuilderUI.InputLabel>Perform a</BuilderUI.InputLabel>
      <SignificanceTestType />
      <KubitTooltip
        placement="top-start"
        noOpenDelay={true}
        {...significanceTestInfo}
      >
        <BuilderUI.InputLabel>Hypothesis Test</BuilderUI.InputLabel>
      </KubitTooltip>
      <BuilderUI.InputLabel>with a</BuilderUI.InputLabel>
      <KubitTooltip
        placement="top-start"
        noOpenDelay={true}
        {...significancePValueInfo}
      >
        <BuilderUI.InputLabel>P-Value</BuilderUI.InputLabel>
      </KubitTooltip>
      <BuilderUI.InputLabel>of</BuilderUI.InputLabel>
      <SignificanceLevel />
      <SignificanceConfidenceLevel />
      <KubitTooltip
        placement="top-start"
        noOpenDelay={true}
        {...significanceConfidenceLevelInfo}
      >
        <BuilderUI.InputLabel>Confidence Level</BuilderUI.InputLabel>
      </KubitTooltip>
    </Container>
  );
};

export default SignificanceTestSettings;
